import { RootState } from '@iwProvider/configureStore';
import { GetStatementsResponse } from '@iwoca/lapi-client/edge';
import _ from 'lodash';

export function getInitialDateFrom({ siteContext }: RootState) {
    // @ts-expect-error For some reason user_date_joined doesn't exist on the RootState for siteContext
    const dateJoined = siteContext.user_date_joined;
    return new Date(dateJoined).toISOString().substring(0, 10);
}

export function getInitialDateTo() {
    return new Date().toISOString().substring(0, 10);
}

export function getAccountHistory(state: RootState, accountId: string) {
    const statement = filterStatements(
        state.api.account_statement.data,
        accountId
    );

    const statements = statement?.statements ?? [];
    return [...statements].reverse();
}

const filterStatements = (
    statements: NonNullable<GetStatementsResponse['data']>,
    accountId: string
) => {
    return statements.filter(
        (statement) => statement.account_id === accountId
    )[0];
};

export function hasMadeTransactions(state: RootState, accountId: string) {
    const statement = filterStatements(
        state.api.account_statement.data,
        accountId
    );

    return _.some(statement.summary, (total) => total !== 0);
}
